import React from "react";
import { Box, Typography } from "@mui/material";
import CGI from "../assests/scroll image/CGI.webp";
import asianPaint from "../assests/scroll image/asianpaint.webp";
import IITPUNE from "../assests/scroll image/IIITPUNE.webp";
import inflooens from "../assests/scroll image/inflooens.webp";
import KSB from "../assests/scroll image/ksb.webp";
import SITPUNE from "../assests/scroll image/SITPUNE.webp";
import rajdeepAuto from "../assests/scroll image/rajdeepauto.webp";

const LogoScroller = ({ title = "Our Partners" }) => {
  const logos = [
    CGI,
    IITPUNE,
    inflooens,
    KSB,
    SITPUNE,
    asianPaint,
    rajdeepAuto,
  ];

  return (
    <Box
      sx={{
        width: "100%",
        overflow: "hidden",
        position: "relative",
        mt: 4,
        py: 2,
      }}
    >
      {/* Title for the scroller */}
      {title && (
        <Typography
          variant="h3"
          sx={{
            textAlign: "center",
            mb: 2,
          }}
          className="heading-color"
        >
          {title}
        </Typography>
      )}

      {/* Scrolling container */}
      <Box
        sx={{
          display: "flex",
          gap: 2, // Space between logos
          animation: "scroll 30s linear infinite",
          whiteSpace: "nowrap",
          backgroundColor: "white",
        }}
      >
        {/* Render logos twice for seamless scrolling */}
        {logos.concat(logos).map((logo, index) => (
          <Box
            key={index}
            sx={{
              display: "inline-block",
              width: "120px", // Logo size
              height: "120px",
              backgroundImage: `url(${logo})`,
              backgroundSize: "contain",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              flexShrink: 0,
            }}
          ></Box>
        ))}
      </Box>

      {/* Smooth scrolling animation */}
      <style>
        {`
          @keyframes scroll {
            from {
              transform: translateX(0%);
            }
            to {
              transform: translateX(-25%);
            }
          }
          
          /* Hide horizontal scrollbar */
          ::-webkit-scrollbar {
            display: none;
          }
          -ms-overflow-style: none; /* IE and Edge */
          scrollbar-width: none; /* Firefox */
        `}
      </style>
    </Box>
  );
};

export default LogoScroller;
